import log from 'loglevel'
import type { ErrorInfo } from 'react'

/**
 * Logs an unexpected error (or message) to the relavant locations.
 * @param error
 * @returns
 */
export const logUnexpectedError = (
  error: string | Error,
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  ...optionalParams: Array<any>
) => {
  // The portal has no remote error-reporting SDK, so console is the only
  // destination for unexpected errors.

  let errorToLog: Error
  if (error instanceof Error) {
    errorToLog = error
  } else {
    errorToLog = new Error(error)
  }

  const errorParams = optionalParams.length > 0 ? optionalParams : undefined

  console.error('Unexpected error:', errorToLog, { ...errorParams })
}

/**
 * Logs a fatal unexpected error. Application is most likely not initialized.
 * @param error
 * @returns
 */
export const logFatalUnexpectedError = (
  error: Error,
  errorInfo?: ErrorInfo | object
) => {
  console.error('Uncaught fatal error:', error, errorInfo)
}

export const loggerAuth0 = log.getLogger('auth0')
